import { useLazyQuery } from 'src/graphql';
import { PAST_RESULTS_QUERY } from 'src/graphql/job/query';

export default (
  {
    limit = 100,
    offset = 0,
    orderBy = 'audit_start_at',
    orderDirection = 'desc',
    auditStartTo=null,
    factoryId = null,
    hasResults = true
  }) =>
  useLazyQuery(PAST_RESULTS_QUERY, {
    variables: {
      limit,
      offset,
      orderBy,
      orderDirection,
      auditStartTo,
      factoryId,
      hasResults
    },
  });
